import {ActivatedRoute, Router} from '@angular/router';
import {Logger} from '../utils/Logger';
import * as moment from 'moment/moment';
import {MatDialog} from '@angular/material/dialog';
import {Component, OnInit} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {Keys, StorageService} from '../service/storage.service';
import {LoanDetailsService} from '../service/loan-details.service';
import {SubventionService} from '../service/subvention.service';
import {SubventionPreferenceService} from '../service/subvention-preference.service';
import {ChannelPartnerService} from '../service/channel-partner.service';
import {SubventionUtil} from '../utils/subvention-util';
import {MathUtil} from '../utils/math.util';
import {ConfigService} from '../service/config.service';
import {WorstEmiScheduleGenerator} from '@finzy/node-emi-calculator/lib/emiCalculator/WorstEmiScheduleGenerator';
import {EffectiveRoiCalculator} from '@finzy/node-emi-calculator/lib/interest/EffectiveRoiCalculator';
import {LoanStatus} from '../model/loan-status.model';
import {HasBreadcrumb} from '../borrow/borrower-dashboard/breadcrumbs/breadcrumb';
import {AsyncSubject} from 'rxjs/index';

@Component({
    selector: 'app-loan-progress',
    templateUrl: './loan-progress.component.html',
    styleUrls: ['./loan-progress.component.scss'],
    providers: [ApiServiceService]
})
export class LoanProgressComponent implements OnInit, HasBreadcrumb {
    private static readonly TenSecondsInMillis = 10000;
    loanDetails: any;
    result: any;
    name: string;
    photo: string;
    loanAmt: number;
    emi_amount: number;
    roi: number;
    loan_tenure: number;
    loanFilled: any;
    loanStatus: string;
    loanprogress: number;
    sanctionedAmt: number;
    activated1 = '';
    activated2 = '';
    activated3 = '';
    activated4 = '';
    contract: string;
    pdform: string;
    nach: string;
    dpn: string;
    emiScheduleLink = false;
    lastInvested: any;
    investLength: number;
    runner: string;
    finzyDomain = true;
    otherDomain = false;
    isReferralSchemeEnabled: boolean;
    partnerDocumentsExist: boolean;
    areDocumentsSigned: boolean;
    shortLoanId = new AsyncSubject<string>();
    public fractionSize = '1.2-2';

    constructor(private router: Router, private ref: ApiServiceService, private storageService: StorageService,
                private loanDetailsService: LoanDetailsService, public dialog: MatDialog, private subventionService: SubventionService,
                private subventionPreferenceService: SubventionPreferenceService, private worstEmiScheduleGenerator: WorstEmiScheduleGenerator,
                private effectiveROICalculator: EffectiveRoiCalculator, private channelPartnerService: ChannelPartnerService,
                private subventionUtil: SubventionUtil,
                private configService: ConfigService,
                private route: ActivatedRoute) {
    }

    async ngOnInit() {
        this.isReferralSchemeEnabled = ApiServiceService.isReferralSchemeEnabled();

        this.route.data.subscribe(async (data) => {
            await this.getAndPopulateLoanDetails(data.loanId);
        });
    }

    private async getAndPopulateLoanDetails(loanId: string): Promise<void> {
        this.loanDetails = await this.loanDetailsService.getLoanDetails(loanId);

        const loanDetails = this.loanDetails.loan_info;
        this.shortLoanId.next(loanDetails.generated_loan_id);
        this.shortLoanId.complete();

        this.scheduleRefreshIfApplicable(loanDetails);


        this.name = loanDetails.profile.name;
        if (loanDetails.document_upload.length > 0) {
            for (let i = 0; i < loanDetails.document_upload.length; i++) {
                if (loanDetails.document_upload[i].type == 'photo') {
                    this.photo = loanDetails.document_upload[i].source;

                }
            }
        } else {
            this.photo = 'https://res.cloudinary.com/finzy/image/upload/v1490882659/default-user-icon-profile_qjsn3w.png';
        }

        this.areDocumentsSigned = LoanStatus.areDocumentsSigned(loanDetails.loan_sanction_status);

        if (loanDetails.contract_documents.length > 0) {
            this.contract = loanDetails.contract_documents[0].source;
        }
        if (loanDetails.nach.nach_upload.length > 0) {
            this.nach = loanDetails.nach.nach_upload[0].source;
        }
        if (loanDetails.dpn_documents.length > 0) {
            this.dpn = loanDetails.dpn_documents[0].source;
        }
        if (loanDetails.channelpartner_documents.length > 0) {
            this.partnerDocumentsExist = true;
            this.pdform = loanDetails.channelpartner_documents[0].source;
        }

        if (loanDetails.runner_status == 'scheduling_in_progress') {

            this.activated2 = 'activated-1';
            this.activated3 = 'activated-1';
            this.activated4 = 'activated-1';
            this.runner = 'We’ll be scheduling a representative to come over and collect few documents, to help enable hassle free loan processing';
        } else if (loanDetails.runner_status == 'scheduled') {
            this.runner = 'We have scheduled for a representative to visit you to help complete the pre-disbursal documentation';
            this.activated1 = 'activated';
            this.activated3 = 'activated-1';
            this.activated4 = 'activated-1';
        } else if (loanDetails.runner_status == 'document_collected') {
            this.runner = 'We have received the signed documents and are currently reviewing them. Your loan would be ready for disbursal as soon as the verification process is completed';
            this.activated1 = 'activated';
            this.activated2 = 'activated';
            this.activated4 = 'activated-1';
        } else if (loanDetails.runner_status == 'ready_for_disbursal' || loanDetails.runner_status == 'document_verified') {
            this.runner = 'Your pre-disbursal documents have been verified and the loan disbursal is in progress. You will receive a notification on successful disbursal';
            this.activated1 = 'activated';
            this.activated2 = 'activated';
            this.activated3 = 'activated';
        } else if (loanDetails.runner_status == 'loan_disbursed' || loanDetails.runner_status == 'document_hardcopy_recieved') {
            this.runner = 'Your loan is disbursed to your bank account successfully';
            this.activated1 = 'activated';
            this.activated2 = 'activated';
            this.activated3 = 'activated';
            this.activated4 = 'activated';
            this.emiScheduleLink = true;
        }

        this.loanFilled = Math.round(loanDetails.filled_percentage);
        if (loanDetails.loan_sanction_status == 'loan_fulfilled' || loanDetails.loan_sanction_status == 'document_collected' || loanDetails.loan_sanction_status == 'document_verified' || loanDetails.loan_sanction_status == 'ready_for_disbursal' || loanDetails.loan_sanction_status == 'loan_disbursed_initiated') {
            this.loanprogress = 100;
            this.loan_tenure = loanDetails.loan_tenure;
            this.loanAmt = loanDetails.loan_amount;
            this.sanctionedAmt = loanDetails.loan_fulfilled_amount;
            const readableAmount = this.sanctionedAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            this.loanStatus = 'Congrats! Your loan for ₹ ' + readableAmount + ' has been funded!';
        } else if (loanDetails.loan_sanction_status == 'loan_disbursed' || loanDetails.loan_sanction_status == 'document_hardcopy_recieved') {
            this.router.navigate(['/borrowerdashboard']);
        } else {
            this.loanprogress = 0;
            this.loanAmt = loanDetails.loan_amount;

            if (this.storageService.getItem(Keys.DOMAIN) == 'tripfactory') {
                this.loanStatus = 'Awesome, we are all set to see your holiday get funded';
            } else {
                this.loanStatus = 'Awesome, we are all set to see you get funded';
            }
            this.loan_tenure = loanDetails.loan_tenure;

            if (loanDetails.lenders_invested && loanDetails.lenders_invested.length > 0) {
                this.investLength = loanDetails.lenders_invested.length;
                const lastContractConsentSignedOnDate = loanDetails.lenders_invested.slice(-1).pop().contract_consent_signed_on;
                this.lastInvested = moment(lastContractConsentSignedOnDate).format('MMMM Do YYYY, h:mm:ss a');
            }

            const isSubvented = await this.subventionUtil.isSubvented(loanId);

            if (isSubvented) {
                const result = await this.subventionUtil.getEffectiveRoiAndEffectiveEmiForSubventedLoan(loanDetails);
                this.roi = MathUtil.roundOff(result.roi);
                this.emi_amount = MathUtil.roundOff(result.emi);
            } else {
                this.roi = loanDetails.roi;
                this.emi_amount = Math.round(loanDetails.emi_amount);
            }
        }
    }

    private scheduleRefreshIfApplicable(loanDetails: any) {
        const loanAcceptedOn = loanDetails.loan_accepted_on;
        const secondsSinceLoanAcceptance = moment().diff(moment(loanAcceptedOn), 'seconds');
        if (secondsSinceLoanAcceptance < 30) {
            Logger.log(`Scheduling a refresh of loan data in [${LoanProgressComponent.TenSecondsInMillis}] milliseconds.`);
            setTimeout(() => {
                this.getAndPopulateLoanDetails(loanDetails._id);
            }, LoanProgressComponent.TenSecondsInMillis);
        }
    }

    public getPostDatedCheckNumberInText(): string {
        if (this.loan_tenure <= this.configService.getMaximumTenureForShortTermLoan()) {
            return this.configService.getRequiredPdcForShortTermLoan();
        } else {
            return this.configService.getRequiredPdcForStandardLoan();
        }
    }

    async breadcrumb(): Promise<string> {
        return this.shortLoanId.toPromise();
    }
}
